<script lang="ts">
  import { xhr, toast } from "$app/utils"
  import Button from "$app/components/ButtonSpinner.svelte"
  import Navigation from "./Navigation.svelte"
  import { appStore } from "$app/store.svelte"

  import bg from "@images/onboarding/bg-eclipse.jpg"

  let { onUpdateStep, onUpdateUser } = $props()

  let errors = {}

  let saving = $state(false)
  async function updateUser() {
    saving = true
    errors = {}
    const formData = new FormData()
    formData.append("user[onboarding_steps][one_page_view]", true)
    try {
      const resp = await xhr.patch(
        `/user_onboarding/${appStore.current_user.id}`,
        formData
      )
      onUpdateUser(resp.data)
    } catch (e) {
      console.error(e.response)
      toast("There was an error", "error")
      if (e.response) {
        errors = { ...errors, ...e.response.data.errors }
      }
    } finally {
      saving = false
    }
  }
</script>

<div class="w-full">
  <div class="px-4 lg:px-6 pt-4 w-full pb-8 lg:pb-12 lg:text-left">
    <Navigation step="one_page_view" {onUpdateStep} />
  </div>

  <div class="relative">
    <div class="mx-auto px-2 lg:px-6 w-full pb-6 lg:pb-12 lg:text-left">
      <div class="px-4 w-full md:w-2/3 lg:w-1/2 xl:w-5/12 md:pr-12 xl:pr-16">
        <h2 class="text-3xl md:text-4xl font-bold text-left text-white">
          One Page View
        </h2>

        {#if appStore.role === "recognition"}
          <p class="mt-4 text-lg text-white leading-6">
            The One Page View (OPV) is a place to see how your day to day
            actions connect to making a difference in the world long-term. The
            first <span class="italic">four elements</span>
            at the top of the OPV include the
            <span class="font-bold text-blue-50"
              >Brand Purpose, Values, Vision, and a full SWOT analysis of your
              organization</span
            >. These are the leadership components of your plan.
          </p>
          <p class="mt-2 md:mt-6 text-lg text-white leading-6">
            When you send or receive a recognition, it will be linked to one or
            more of these critical leadership components, specifically the Brand
            Purpose, Blue Sky Vision or Values. By connecting each recognition
            to these core company components you will see how your actions are
            furthering the larger mission and you are helping to build a culture
            of encouragement and recognition.
          </p>
        {:else}
          <p class="mt-4 text-lg text-white leading-6">
            The One Page View (OPV) is a place to see how your day to day goals
            connect to making a difference in the world long-term. The first <span
              class="italic">four elements</span
            >
            at the top of the OPV include the
            <span class="font-bold text-blue-50"
              >Brand Purpose, Values, Vision, and a full SWOT analysis of your
              organization</span
            >. These are the leadership components of your plan.
          </p>
          <p class="mt-2 md:mt-6 text-lg text-white leading-6">
            Further down the screen are your <span
              class="font-bold text-blue-50"
              >long term goals, annual goals, and quarterly goals</span
            >
            by department (also known as the management components of your plan).
            As you
            <span class="italic">hover</span>
            over any of the goals, you will notice that the highlighted goals are
            linked together through the following methodology -
            <span class="font-bold text-blue-50"
              >a quarterly goal in a department links to a highlighted annual
              goal which helps to complete the corresponding highlighted long
              term goal</span
            >. Additionally, you can keep your team up to date by changing the
            status of the goal to show if it is
            <span class="font-bold text-green-400">on track</span>
            or is <span class="font-bold text-red-400">critical</span> and needs
            attention.
          </p>
        {/if}

        <div
          class="relative w-full block lg:hidden mt-4 md:mt-10 border border-gray-600"
        >
          <video playsinline autoplay loop muted preload="metadata">
            <source
              src="https://leadwithpurpose-web.s3.amazonaws.com/onboarding/one_page_view.mp4"
              type="video/mp4"
            />
          </video>
        </div>

        <div class="mt-4 lg:mt-6 max-w-md mx-auto flex justify-center">
          <Button
            onclick={updateUser}
            processing={saving}
            class="btn-rounded bg-green-600 hover:bg-green-700 text-white btn-big w-full text-lg font-bold md:w-60 h-14"
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
    <div
      class="hidden relative lg:inline-block lg:absolute lg:inset-y-0 lg:-right-0 lg:w-1/2 xl:w-7/12 lg:h-full bg-lwp-light-grey bg-right-bottom bg-no-repeat bg-contain"
      style="background-image: url({bg});"
    >
      <div class="absolute inset-0 w-full p-2">
        <video
          autoplay
          playsinline
          loop
          muted
          preload="metadata"
          class="shadow-lg border border-gray-400"
        >
          <source
            src="https://leadwithpurpose-web.s3.amazonaws.com/onboarding/one_page_view.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </div>
  </div>
</div>
